import LoginComponent from "./LoginComponent";
export default LoginComponent;
